import React, {useRef} from 'react'

import {CameraIcon} from '../icons'
import {Image} from '../image'
import {Link} from '../link'
import {ListItem, ListItemBase} from '../list'
import {Lead, Text} from '../slot'
import {Typography} from '../typography'
import {Account} from './types'
import {classes, listClasses} from './UserItem.classes'
import {safeReturnPath, toAvatarSources} from './utils'

type Props = {
  account: Account
  avatarUrl: string
  cameraUrl?: string
  passportHost: string
  returnPath: string
  yui: string
}

const UserItem: React.FC<Props> = ({account, avatarUrl, cameraUrl, returnPath, yui, passportHost}) => {
  const {
    uid,
    displayName: {name, default_avatar: defaultAvatar},
    defaultEmail,
  } = account
  const formRef = useRef<HTMLFormElement | null>(null)
  const isClickable = !cameraUrl
  const ListItemComponent = isClickable ? ListItem : ListItemBase
  const clickHandler = () => isClickable && formRef.current?.submit()

  return (
    <ListItemComponent className={listClasses.listItem} onPress={clickHandler}>
      <Lead>
        <div className={classes.image}>
          <Image
            alt={name}
            className={classes.avatar}
            height={42}
            srcSet={toAvatarSources(avatarUrl, defaultAvatar)}
            width={42}
          />
          {cameraUrl && (
            <Link className={classes.camera} href={cameraUrl}>
              <CameraIcon fontSize="inherit" />
            </Link>
          )}
        </div>
      </Lead>
      <Text pl="s">
        <Typography variant="body2">{name}</Typography>
        <Typography color="minor" variant="caption1">
          {defaultEmail}
        </Typography>
      </Text>
      <>
        <form ref={formRef} action={`${passportHost}/passport?mode=embeddedauth`} method="post">
          <input name="yu" type="hidden" value={yui} />
          <input name="retpath" type="hidden" value={safeReturnPath(returnPath)} />
          <input name="uid" type="hidden" value={uid} />
          <input name="action" type="hidden" value="change_default" />
        </form>
      </>
    </ListItemComponent>
  )
}

export default UserItem
